import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import * as fromAuth from './auth.reducer';
import * as fromOrganization from './organization.reducer';
import * as fromRoot from '../../reducers';
import {Organization} from '../models/organization';

export interface AfbGraphqlApiState {
  auth: fromAuth.State;
  organization: fromOrganization.State;
}

export interface State extends fromRoot.State {
  afbGraphqlApi: AfbGraphqlApiState;
}

export const reducers: ActionReducerMap<AfbGraphqlApiState> = {
  auth: fromAuth.reducer,
  organization: fromOrganization.reducer
};

/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const afbGraphqlApiState = createFeatureSelector<AfbGraphqlApiState>('afbGraphqlApi');

export const authState = createSelector(
  afbGraphqlApiState,
  (state: AfbGraphqlApiState) => state.auth
);

export const organizationState = createSelector(
  afbGraphqlApiState,
  (state: AfbGraphqlApiState) => state.organization
);

// Auth
export const accessToken = createSelector(
  authState,
  fromAuth.accessToken
);
export const isLoginLoading = createSelector(
  authState,
  fromAuth.isLoginLoading
);
export const isLoginLoaded = createSelector(
  authState,
  fromAuth.isLoginLoaded
);
export const loginError = createSelector(
  authState,
  fromAuth.loginError
);
export const user = createSelector(
  authState,
  fromAuth.user
);

// Organization
export const organizationEntities = createSelector(
  organizationState,
  fromOrganization.organizationEntities
);
export const selfOrganization = createSelector(
  organizationState,
  fromOrganization.selfOrganization
);
export const isGetOrganizationsLoading = createSelector(
  organizationState,
  fromOrganization.isGetOrganizationsLoading
);
export const isGetOrganizationsLoaded = createSelector(
  organizationState,
  fromOrganization.isGetOrganizationsLoaded
);
export const getOrganizationsError = createSelector(
  organizationState,
  fromOrganization.getOrganizationsError
);
export const isPostOrganizationLoading = createSelector(
  organizationState,
  fromOrganization.isPostOrganizationLoading
);
export const isPostOrganizationLoaded = createSelector(
  organizationState,
  fromOrganization.isPostOrganizationLoaded
);
export const postOrganizationError = createSelector(
  organizationState,
  fromOrganization.postOrganizationError
);
export const isGetSelfOrganizationLoading = createSelector(
  organizationState,
  fromOrganization.isGetSelfOrganizationLoading
);
export const isGetSelfOrganizationLoaded = createSelector(
  organizationState,
  fromOrganization.isGetSelfOrganizationLoaded
);
export const getSelfOrganizationError = createSelector(
  organizationState,
  fromOrganization.getSelfOrganizationError
);
export const organizations = createSelector(
  organizationEntities,
  (entities: { [id: string]: Organization }) => Object.keys(entities).reduce((acc: Organization[], key: string) => {
    return [
      ...acc,
      entities[key]
    ];
  }, [])
);
export const activatedOrganizations = createSelector(
  organizations,
  (_organizations: Organization[]) => _organizations.filter((organization: Organization) => organization.isActivated === true)
);
export const deactivatedOrganizations = createSelector(
  organizations,
  (_organizations: Organization[]) => _organizations.filter((organization: Organization) => organization.isActivated === false)
);
export const pendingOrganizations = createSelector(
  organizations,
  (_organizations: Organization[]) => _organizations.filter((organization: Organization) => organization.isActivated == null)
);
